import type { WmsCapabilities } from "./wmsCapabilities";
import { parseWmsCapabilities } from "./wmsCapabilities";

export interface SavedWmsEntry {
  url: string;
  title: string;
}

export type WmsCategory = "land-registry" | "planning-law" | "brw";

export interface CuratedWmsEntry {
  id: string;
  title: string;
  url: string;
  layerName?: string;
  bounds: [[number, number], [number, number]];
  state: string;
  category: WmsCategory;
  attribution?: string;
}

export type CatalogEntry = SavedWmsEntry | CuratedWmsEntry;

export function pointInBounds(
  point: { lng: number; lat: number },
  bounds: [[number, number], [number, number]]
): boolean {
  const [[w, s], [e, n]] = bounds;
  return point.lng >= w && point.lng <= e && point.lat >= s && point.lat <= n;
}

function ensureCapabilitiesParams(rawUrl: string): string {
  const url = new URL(rawUrl);
  const params = url.searchParams;
  const get = (key: string) =>
    [...params.keys()].find((k) => k.toLowerCase() === key.toLowerCase());
  if (!get("service")) params.set("service", "WMS");
  if (!get("request")) params.set("request", "GetCapabilities");
  if (!get("version")) params.set("version", "1.3.0");
  url.search = params.toString();
  return url.toString();
}

export async function fetchAndParseCapabilities(rawUrl: string): Promise<{
  capabilities: WmsCapabilities;
  fullUrl: string;
}> {
  const fullUrl = ensureCapabilitiesParams(rawUrl);
  const res = await fetch(fullUrl);
  if (!res.ok) throw new Error("fetchFailed");
  const text = await res.text();
  const capabilities = parseWmsCapabilities(text);
  return { capabilities, fullUrl };
}
